import { useRule } from "../CreateRuleNew/RuleReducer";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import classes from "./RuleWizard.module.css";

const WizardStepWhatToDo = ({ onNext, onBack }) => {
    const { state, dispatch } = useRule();

    const handleOutputsChange = (checked) => {
        dispatch({ type: "SET_WANT_OUTPUTS", payload: checked });
        if (!checked) {
            dispatch({ type: "SET_ADV_RULE_ACTION", payload: state.actions.filter(a => a.action_type !== "CONTROL_OUTPUT") });
            dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
        }
    };

    const handleAlertChange = (checked) => {
        dispatch({ type: "SET_WANT_ALERT", payload: checked });
        if (checked) {
            const alertAction = {
                site_to: state.deviceUUID,
                action_type: "SEND_ALERT",
                target_output: 0,
                execution_order: state.actions.filter(a => a.action_type !== "SEND_ALERT").length + 1,
                delay_seconds: 0,
                alert_recipient_type: null,
                alert_level: "STANDARD",
                critical_notification: false,
            };
            dispatch({ type: "SET_ADV_RULE_ACTION", payload: [...state.actions.filter(a => a.action_type !== "SEND_ALERT"), alertAction] });
        } else {
            dispatch({ type: "SET_ADV_RULE_ACTION", payload: state.actions.filter(a => a.action_type !== "SEND_ALERT") });
        }
    };

    const handleAlertArcChange = (checked) => {
        dispatch({ type: "SET_WANT_ARC_ALERT", payload: checked });
    }

    const handleSnapshotChange = (checked) => {
        dispatch({ type: "SET_WANT_SNAPSHOT", payload: checked });
    }

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>What should happen?</h2>
                <p className={classes.contentSubtitle}>Choose what this rule does when it triggers</p>
            </div>

            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${state.wantOutputs ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: state.wantOutputs ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => handleOutputsChange(!state.wantOutputs)}
                >
                    <Checkbox checked={state.wantOutputs} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Affect outputs</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Control one or more outputs on a site</p>
                    </div>
                </div>

                {/* <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${state.wantAlert ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: state.wantAlert ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => handleAlertChange(!state.wantAlert)}
                >
                    <Checkbox checked={state.wantAlert} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Send alert</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Send a notification to all or selected users</p>
                    </div>
                </div> */}

                 {/* <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${state.wantSnapshot ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: state.wantSnapshot ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => handleSnapshotChange(!state.wantSnapshot)}
                >
                    <Checkbox checked={state.wantSnapshot} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Take snapshot</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Take a camera snapshot using the connected CCTV system</p>
                    </div>
                </div> */}

                {/* <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${state.wantArcAlert ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: state.wantArcAlert ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => handleAlertArcChange(!state.wantArcAlert)}
                >
                    <Checkbox checked={state.wantArcAlert} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Send alert to arc</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Send an alert to the monitoring arc, without notifying users</p>
                    </div>
                </div> */}
            </div>

            <div className={classes.navRow}>
                <Button label="Back" icon="pi pi-arrow-left" severity="secondary" outlined onClick={onBack} />
                <Button
                    label="Next"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    severity="success"
                    disabled={!state.wantOutputs && !state.wantAlert && !state.wantSnapshot}
                    onClick={onNext}
                />
            </div>
        </>
    );
};

export default WizardStepWhatToDo;
